import * as types from '../mutation-types';
import {unionState} from '../helpers';

const state = () => ({
	types: [],
});

const actions = {
	fetchAll({commit}) {
		return axios.get('/api/contact-info-types').then(response => {
			commit(types.STORE_CONTACT_INFO_TYPES, response.data);

			return response.data;
		});
	},
};

const mutations = {
	[types.STORE_CONTACT_INFO_TYPES](state, types) {
		state.types = unionState(state.types, types);
	}
};

const getters = {
	getById: state => id => state.types.find(t => t.id === id),
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};